import { keyframes } from 'styled-components';
const animations = {
    shake: keyframes `
  0% {
      transform: translateX(0);
    }

    25% {
      transform: translateX(5px);
    }

    50% {
      transform: translateX(-5px);
    }

    75% {
      transform: translateX(5px);
    }

    100% {
      transform: translateX(0);
    }
  `,
};
export default animations;
//# sourceMappingURL=animations.js.map